import { FilterValue } from "../models/Filters/FilterValue";

export const ALL_PAYMENT_CYCLE_TAB = "all";

const pad2 = (value: number): string => String(value).padStart(2, "0");

const formatCycleId = (date: Date): string =>
  `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;

const formatCycleLabel = (date: Date): string =>
  date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

const getCycleDate = (year: number, month: number, day: number): Date => {
  const lastDayOfMonth = new Date(year, month + 1, 0).getDate();
  return new Date(year, month, Math.min(day, lastDayOfMonth));
};

const getCycleDatesAroundToday = (today: Date): Date[] => {
  const dates: Date[] = [];

  for (let monthOffset = -3; monthOffset <= 4; monthOffset += 1) {
    const monthDate = new Date(
      today.getFullYear(),
      today.getMonth() + monthOffset,
      1,
    );
    dates.push(
      getCycleDate(monthDate.getFullYear(), monthDate.getMonth(), 15),
    );
    dates.push(
      getCycleDate(monthDate.getFullYear(), monthDate.getMonth(), 30),
    );
  }

  const uniqueById = new Map<string, Date>();
  dates.forEach((date) => {
    uniqueById.set(formatCycleId(date), date);
  });

  return Array.from(uniqueById.values()).sort(
    (left, right) => left.getTime() - right.getTime(),
  );
};

/**
 * Payment cycles fall on the 15th and 30th (or last day if the month has no 30th).
 * Tabs: previous 2 cycles + upcoming 4 cycles.
 * Example on 27 Aug: 30 Jul (Prev), 15 Aug (Prev), 30 Aug, 15 Sep, 30 Sep, 15 Oct.
 */
export const getVendorInvoicePaymentCycleFilters = (
  now: Date = new Date(),
): FilterValue[] => {
  try {
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const todayTime = today.getTime();
    const cycleDates = getCycleDatesAroundToday(today);

    const previousCycles = cycleDates
      .filter((date) => date.getTime() <= todayTime)
      .slice(-2);
    const upcomingCycles = cycleDates
      .filter((date) => date.getTime() > todayTime)
      .slice(0, 4);

    return [
      ...previousCycles.map((date) => ({
        id: formatCycleId(date),
        value: `${formatCycleLabel(date)} (Prev)`,
      })),
      ...upcomingCycles.map((date) => ({
        id: formatCycleId(date),
        value: formatCycleLabel(date),
      })),
    ];
  } catch (error) {
    console.error("getVendorInvoicePaymentCycleFilters - Error:", error);
    return [];
  }
};

export const getVendorInvoicePaymentCycleTabs = (
  now: Date = new Date(),
): FilterValue[] => {
  try {
    return [
      { id: ALL_PAYMENT_CYCLE_TAB, value: "All" },
      ...getVendorInvoicePaymentCycleFilters(now),
    ];
  } catch (error) {
    console.error("getVendorInvoicePaymentCycleTabs - Error:", error);
    return [{ id: ALL_PAYMENT_CYCLE_TAB, value: "All" }];
  }
};
